import script from "./PrivacyAnimatedIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyAnimatedIcons.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyAnimatedIcons.vue?vue&type=style&index=0&id=4f97d675&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f97d675"]])

export default __exports__